module.exports = __webpack_public_path__ + "static/media/banner-e2.45b7270b.jpg";